var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"home"}},[_c('Header'),_c('Banner'),_c('Provocadores'),_c('JustMind'),_c('MindMethod'),_c('Solucoes')],1)}
var staticRenderFns = []

export { render, staticRenderFns }